import { getCaseType } from 'Utils'
import React, { useContext, useState } from 'react'
import { Link } from 'react-router-dom';
import MiniStepper from './MiniStepper';
import moment from 'moment';
import CaseTableLoading from 'Components/Icons/CaseTableLoading';
import EmptyCaseList from 'Components/Professional/Cases/EmptyCaseList';
import { Expand, Trash } from 'lucide-react';
import AreYouSureModal from 'Modals/AreYouSureModal';
import { deleteCaseApi } from 'Constants';
import { Context } from 'Context/Context';


function ClientCaseListRender({caseList, setUpdateCaseList, updateCaseList}) {
    const [showModal, setShowModal] = useState(false);
  const [deleteCaseID, setDeleteCaseID] = useState(null);
  const {makeApiCallFunc} = useContext(Context);
    const getStatus = (item) => {
        if(item.isClosed)
        {
            return 6;
        }
        if(item?.isCasePendingClosing)
        {
            return 5;
        }
        if(item?.noConflict)
        {
            return 4;
        }
        if(item?.approved)
        {
            return 3;
        }
        if(item?.requests)
        {
            return 2;
        }
        return 1;
    }
    // /case/all returns per-case counts: requests (pending), approved, noConflict, isCasePendingClosing, isClosed
    const plural = (n, word) => n + ' ' + word + (n === 1 ? '' : 's');
    const getCaseAction = (item) => {
        const requests = Number(item?.requests) || 0;
        const approved = Number(item?.approved) || 0;
        const cleared = Number(item?.noConflict) || 0;
        if (item?.isClosed) return { tone: 'muted', badge: 'Closed', note: 'This case is closed' };
        if (item?.isCasePendingClosing) return { tone: 'action', badge: 'Close request', note: 'Confirm closing this case', cta: true };
        if (requests > 0) return { tone: 'action', badge: plural(requests, 'new request'), note: 'Review ' + plural(requests, 'request'), cta: true };
        if (cleared > 0) return { tone: 'good', badge: plural(cleared, 'attorney') + ' cleared', note: 'Conflict check cleared' };
        if (approved > 0) return { tone: 'good', badge: approved + ' approved', note: 'Waiting for conflict check' };
        return { tone: 'muted', badge: 'No requests yet', note: 'Waiting for attorneys to request' };
    };
    const badgeClass = {
        action: 'text-brass bg-brass/[.08] border border-brass/[.3]',
        good: 'text-success bg-success/[.08] border border-success/[.3]',
        muted: 'text-navy/[.5] bg-cream border border-navy/[.16]',
    };
    const getDateDiff = (d1) => {
        const b = moment(d1).utc();
        const d = new Date();
        
        const a = moment(d).utc();
                
        if (a.isSame(b, 'day')) return "Today";

        let years = a.diff(b, 'year');
        const bCloneYear = moment(b); // Clone `b` to avoid mutation issues
        bCloneYear.add(years, 'years');

        let months = a.diff(bCloneYear, 'months');
        const bCloneMonth = moment(bCloneYear); // Clone again
        bCloneMonth.add(months, 'months');

        let days = a.diff(bCloneMonth, 'days');

        const yearStr = years > 1 ? `${years} years` : years === 1 ? '1 year' : '';
        const monthStr = months > 1 ? `${months} months` : months === 1 ? '1 month' : '';
        const dayStr = days > 1 ? `${days} days` : days === 1 ? '1 day' : '';

        // Concatenate non-empty parts
        const diff = [yearStr, monthStr, dayStr].filter(Boolean).join(' ');
        return diff ? `${diff} ago` : "Today";
    }
     const deleteCase = () => {
        if(!deleteCaseID?._id) return;
           makeApiCallFunc(
            deleteCaseApi,
            { id: deleteCaseID?._id },
            ({data})=>
            {
                setShowModal(false);
                setUpdateCaseList(!updateCaseList);
                setDeleteCaseID(null);
                console.log(data)
            },
            function (error) {
                console.log(error)
            }
           )
        }

  return (  
    <>
  {
        showModal &&
        <AreYouSureModal
        uploadNew= {showModal}
        text={"Are you sure you want to delete your \"" + getCaseType(deleteCaseID?.caseType) + "\" case against \"" + deleteCaseID?.adversePartyName + "\" ?"}
         onClose={()=> setShowModal(false)}
         onSubmit = {deleteCase}
         buttonName = "Yes, delete it"
        />
    }
        <div className='w-full flex flex-col font-plexsans'>

              {caseList ? (caseList?.length === 0 ?
              <EmptyCaseList />: 
              (caseList &&
              
             <div className="flex flex-col gap-3.5">
                {caseList?.map((item, key) => {
                    const action = getCaseAction(item);
                    return (
                    <Link
                    to={"/client/caseDetails/" + item._id + (action.cta ? "?tab=details" : "")}
                    key={item._id}
                    className={`flex flex-col gap-2.5 rounded bg-ivory border border-navy/[.14] py-[18px] px-5 ${action.cta ? 'border-l-[3px] border-l-brass' : ''}`}
                    >
                        <div className="flex justify-between items-baseline">
                            <span className='font-plexmono font-normal text-[11px] leading-none text-navy/[.45]'>
                                {item.caseNumber}
                            </span>
                            <span className={`font-plexmono font-medium text-[10px] leading-none tracking-[.08em] uppercase py-1 px-2 rounded-sm whitespace-nowrap ${badgeClass[action.tone]}`}>
                                {action.badge}
                            </span>
                        </div>
                        <div className='font-spectral font-normal text-[17px] leading-[1.3] text-navy'>
                            {getCaseType(item.caseType)}
                        </div>
                        <div className='font-plexsans font-normal text-[11.5px] leading-[1.5] text-navy/[.5]'>
                            Posted {getDateDiff(moment(item.created_at).format("MM-DD-YYYY"))} &nbsp;·&nbsp; Adverse party {item.adversePartyName}
                        </div>
                        {item.aiEstimate ?
                            <div className='font-spectral font-normal text-[20px] leading-none text-navy'>
                                ${(Number(item.aiEstimate.lowerValue).toLocaleString('en-US')) === 'NaN' ?
                                item.aiEstimate.lowerValue :
                                Number(item.aiEstimate.lowerValue).toLocaleString('en-US')}
                                &nbsp;–&nbsp;
                                ${Number(item.aiEstimate.upperValue).toLocaleString('en-US') === 'NaN' ?
                                item.aiEstimate.upperValue :
                                Number(item.aiEstimate.upperValue).toLocaleString('en-US')}
                            </div>
                            :
                            <div className='font-plexsans font-normal text-[13px] leading-[1.5] text-navy/[.4]'>Estimate not available</div>
                        }
                        <MiniStepper currentStep={getStatus(item)} />
                        <div className="flex justify-between items-center font-plexsans font-normal text-[11px] leading-[1.4] text-navy/[.5]">
                            <span className={action.cta
                                ? 'font-plexsans font-semibold text-[12.5px] leading-[1.4] text-brass'
                                : 'font-plexsans font-normal text-[11.5px] leading-[1.4] text-navy/[.5]'}>
                                {action.note}{action.cta ? ' →' : ''}
                            </span>
                            <span className="flex items-center gap-2.5">
                                <Expand className="cursor-pointer w-3.5 h-3.5"/>
                                <Trash
                                className="cursor-pointer w-3.5 h-3.5"
                                onClick={(e) => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    setShowModal(true);
                                    setDeleteCaseID(item);
                                }}
                                />
                            </span>
                        </div>
                    </Link>
                )})}
            </div>
              ))
        :
        <div className='w-full lg:px-10 h-[300px] flex items-center justify-center'>
    <CaseTableLoading/>
            
        </div>
        }
    </div>
    </>        
  )
}

export default ClientCaseListRender
